import ProductStats from "./ProductStats";
import OrderList from "./OrderList";
import React, {useEffect, useState} from "react";
import FloatingActionButton from "../Common/Button/FloatingActionButton";
import {Link,} from "react-router-dom";
import NotiOrder from "./NotiOrder";
import {fetchOrderCountStatusAllTime, fetchOrderCountStatusMonth} from "../../services/orderServices";
import {useOrdersStore} from "../../store/orderStore";
import productStore from "../../store/productStore";
import merchantStore from "../../store/merchantStore";
import ImageBasic from "../Common/Image/ImageBasic";
import IMG from "../../constants/image";
import {PATH} from "../../constants";
import {fetchCountNoti, fetchNotification} from "../../services/notiServices";

const StoreDashboard = () => {
  const {orderCountStatusAllTime} = useOrdersStore();
  const {statusCount, getStatusCount, clearProductData} = productStore() || {};
  const {merchantProfile} = merchantStore() || {};
  const {
    sellerConfirm,
    sellerPrepared,
    shippingProcessing,
    shippingDone,
    orderCancel,
    orderRefund
  } = orderCountStatusAllTime || {}
  // Lấy tháng hiện tại làm giá trị mặc định
  const currentDate = new Date();
  const defaultMonth = `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [isMonthSelectorOpen, setIsMonthSelectorOpen] = useState(false);
  const [orderData, setOrderData] = useState({
    total: 0,
    items: [
      {label: 'Đơn chờ xác nhận', count: 0, isHighlight: false, status: 'seller_prepared'},
      {label: 'Bàn giao cho nhà vận chuyển', count: 0, status: 'seller_prepared'},
      {label: 'Đang vận chuyển', count: 0, status: 'shipping_processing'},
      {label: 'Giao thành công', count: 0, status: 'shipping_done'},
      {label: 'Đơn bị huỷ', count: 0, status: 'order_cancel'},
      {label: 'Đơn bị hoàn/ trả', count: 0, status: 'order_refund'}
    ]
  });

  const handleMonthChange = (monthValue) => {
    setIsMonthSelectorOpen(isMonthSelectorOpen)
    setSelectedMonth(monthValue);
    fetchOrderCountStatusMonth({
      'filter-date': monthValue
    })
  };
  useEffect(() => {
    setOrderData({
      total: sellerConfirm +
        sellerPrepared +
        shippingProcessing +
        shippingDone +
        orderCancel +
        orderRefund,
      items: [
        {
          label: 'Đơn chờ xác nhận',
          count: sellerConfirm + sellerPrepared,
          isHighlight: sellerConfirm > 0 || sellerPrepared > 0,
          status: 'seller_confirm'
        },
        {
          label: 'Bàn giao cho nhà vận chuyển',
          count: sellerPrepared,
          status: 'seller_prepared'
        },
        {
          label: 'Đang vận chuyển',
          count: shippingProcessing,
          status: 'shipping_processing'
        },
        {
          label: 'Giao thành công',
          count: shippingDone,
          status: 'shipping_done'
        },
        {
          label: 'Đơn bị huỷ',
          count: orderCancel,
          status: 'order_cancel'
        },
        {
          label: 'Đơn bị hoàn/ trả',
          count: orderRefund,
          status: 'order_refund'
        }
      ]
    })
  }, [orderCountStatusAllTime]);

  useEffect(() => {
    fetchOrderCountStatusAllTime()
    fetchNotification({
      page: 1,
      size: 5,
      type: 'seller_order'
    })
    fetchCountNoti({
      type: 'seller_order'
    })
  }, [])

  useEffect(() => {
    if (merchantProfile?.id) {
      getStatusCount();
    }
    return () => {
      clearProductData();
    }
  }, [merchantProfile?.id])
  return (
    <div className="animate-fadeIn max-w-4xl mx-auto px-4 space-y-4">
      <Link to={PATH.ACCOUNT_SETTING}
            className='md:hidden flex justify-between items-center p-4 bg-white rounded-lg md:rounded-xl'>
        <div className='flex items-center space-x-2'>
          <ImageBasic src={merchantProfile?.avatar_url || IMG.icon.userCircle}
                      alt="User Avatar"
                      className="w-12 h-12 rounded-full"/>
          <div className='text-sm space-y-1'>
            <div className='font-bold'>{`${merchantProfile?.merchant_name}`}</div>
            <div className='text-xs'>{merchantProfile?.phone_number
              ? `${merchantProfile.phone_number.slice(0, 3)}****${merchantProfile.phone_number.slice(-3)}`
              : ""}</div>
          </div>
        </div>
        <ImageBasic className='w-6 h-6' src={IMG.icon.chevronRightBlack} alt={''}/>
      </Link>
      <ProductStats stats={statusCount}/>
      <OrderList
        orders={orderData}
        onMonthChange={handleMonthChange}
        selectedMonth={selectedMonth}
        isOpen={isMonthSelectorOpen}
        setIsOpen={setIsMonthSelectorOpen}
      />
      <NotiOrder/>
      <FloatingActionButton>
        <video src="/video/taosanpham.mp4" playsInline muted autoPlay loop/>
      </FloatingActionButton>
    </div>
  );
};

export default StoreDashboard;
